import { render, staticRenderFns } from "./CostSet.vue?vue&type=template&id=56d972c7&scoped=true&"
import script from "./CostSet.vue?vue&type=script&lang=js&"
export * from "./CostSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d972c7",
  null
  
)

export default component.exports